import styled from "styled-components";

const SignUpFormContainer = styled.div`
  background-color: white;
  width: 100%;
  padding: 30px 0;
  border-radius: 10px;
  overflow: auto;
  max-height: 650px;

  > form {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 18px;

    > * {
      width: 100%;
    }

    > button {
      margin-top: 20px;
      width: 50%;
      background-color: ${(props) => props.theme.colors.primary};

      :hover {
        background-color: ${(props) => props.theme.colors.secondary};
      }
    }
  }
`;

const SignUpFormLogo = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 15px;

  svg {
    width: 100%;
    max-height: 12vh;
  }
`;

export { SignUpFormContainer, SignUpFormLogo };
